import React, { FC } from "react";
import GenericAuthForm from "../GenericAuthForm/GenericAuthForm";

const ResetPassword: FC = () => {
   return <GenericAuthForm />;
};

export default ResetPassword;
